import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { PromocionesService } from '../../services/promociones.service';
import { UtilsService } from 'src/app/shared/utils/utils.service';
import { LfsaBotonEditarGridComponent } from 'src/app/shared/components/lfsa-boton-editar-grid/lfsa-boton-editar-grid.component';
import { LfsaBotonsGridComponent } from 'src/app/shared/components/lfsa-botons-grid/lfsa-botons-grid.component';
import { Submarca } from '../../modelos/Promocion';

@Component({
  selector: 'app-promocion-submarca',
  templateUrl: './promocion-submarca.component.html',
  styleUrls: ['./promocion-submarca.component.css']
})
export class PromocionSubmarcaComponent implements OnInit {

  gridApi: any;
  gridColumnApi: any;
  columnDefsCondSubmarca = [];
  frameworkComponents: any;
  rowDataCondSubmarca: any[] = [];
  verFormularioAgregarCondSubmarca = false;

  idPromo: string;

  constructor(
    private readonly route: ActivatedRoute,
    private readonly promocionesService: PromocionesService,
    private readonly _util: UtilsService
  ) {
    this.gridComponent();
  }

  ngOnInit(): void {
    this.route.params.subscribe((params) => {
      const id = params['id'] as string
      if (id) {
        this.idPromo = id;
        this.cargarCondSubmarca(id);
      }
    });
  }

  onGridReady(params) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
    params.api.sizeColumnsToFit();
  }

  gridComponent() {
    this.frameworkComponents = {
      buttonRenderer: LfsaBotonEditarGridComponent,
      iconButtonRenderer: LfsaBotonsGridComponent
    };

    this.columnDefsCondSubmarca = [
      {
        headerName: 'Submarca',
        field: 'id_submarca',
        sortable: true,
        filter: true
      },
      {
        headerName: 'Descripción',
        field: 'name_submarca',
        sortable: true,
        filter: true
      },
      {
        headerName: '',
        cellRenderer: 'buttonRenderer',
        width: 40,
        cellRendererParams: {
          onClick: this.eliminarCondSubmarca.bind(this),
          label: 'Eliminar',
          colorBoton: 'btn btn-danger btn-block'
        },
      },
    ];
  }

  cargarCondSubmarca(id_promo) {
    this.promocionesService.cargarCondSubmarca(id_promo.trim()).subscribe(
      (resp) => {
        if (resp) {
          this.rowDataCondSubmarca = resp;
        } else {
          this.rowDataCondSubmarca = [];
        }
      },
      (error) => {
        this.rowDataCondSubmarca = [];
      }
    );
  }

  nuevoCondVendedor() {
    this.verFormularioAgregarCondSubmarca = true;
  }

  back() {
    this.verFormularioAgregarCondSubmarca = false;
  }

  eliminarCondSubmarca({ rowData }) {
    this._util
      .confirmarSincronoPromesa({
        title: 'Eliminar',
        action: 'Eliminar',
        funcion: this.promocionesService.borrarCondSubmarca(rowData),
      })
      .then((res: any) => {
        this.cargarCondSubmarca(this.idPromo);
      });
  }

  guardarCondSubmarca(submarcas: Submarca[]) {
    const body = submarcas.map((submarca) => ({
      id_promo: this.idPromo,
      id_submarca: submarca.idSubMarca
    }));

    this._util
      .confirmarSincronoPromesa({
        title: '¿Esta seguro que desea procesar el siguiente formulario?',
        action: 'Nuevo',
        funcion: this.promocionesService.crearCondSubmarcaLista(body),
      })
      .then((res: any) => {
        this.cargarCondSubmarca(this.idPromo);
        this.verFormularioAgregarCondSubmarca = false;
      });
  }

}
